import { render, staticRenderFns } from "./CoursewareCrud.vue?vue&type=template&id=5be85458&"
import script from "./CoursewareCrud.vue?vue&type=script&lang=js&"
export * from "./CoursewareCrud.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports